<template>
  <nav class="navbar" :class="{ 'navbar--dropdown-active': showDropdown }">
    <div class="navbar__content">
      <div class="navbar__menu" v-on:click="$emit('toggle-dropdown')">
        <svg
          class="navbar__logo"
          version="1.1"
          id="Layer_1"
          x="0px"
          y="0px"
          viewBox="0 0 290.5 290.5"
          style="enable-background: new 0 0 290.5 290.5"
        >
          <g class="mainLogoIcon">
            <path
              d="M46.4,189.6c4.7-12.5,8.8-25.3,14.2-37.5c5.6-12.5,12.5-24.3,18.7-36.4c11.9,4.7,15.3,9.5,13.2,20.7
								c-1.2,6.8-4.1,13.4-6.4,20c-0.9,2.7-2.1,5.4-3.2,8c0.6,0.5,1.3,1,1.9,1.6c6.9-7.3,14-14.5,20.7-22c3.7-4.2,7.5-7.6,13.6-6.9
								c6.8,0.7,10.2,3.2,10,10c-0.2,8-1.9,15.9-3,23.9c-0.7,4.6-1.8,9.2,2.7,14.6c4-1.8,8.4-3.1,12.1-5.6c5-3.4,9.8-7.2,13.8-11.7
								c3.2-3.6,6.2-8,7.4-12.6c8.3-32.8,23.1-62,45.7-87.2c2,0,4,0,6.1,0c2.6,2.6,5.3,5.1,7.6,7.9c4,4.8,8.5,9.5,7.1,16
								c-3.8,2-7.6,2.9-9.8,5.3c-13.8,15.2-26.4,31.3-32.8,51.2c-1.8,5.8-2.9,11.8-4.3,17.7c0.7,0.2,1.4,0.5,2.1,0.7
								c2.7-3.7,5.3-7.5,8.1-11.1c3.6-4.8,7.9-8.8,14.4-6.8c6.5,2,9.1,7.4,9.8,13.8c0.3,3.1,0.7,6.2,1.3,10.7c10-5.4,18.4-10,26.8-14.6
								c0,2,0,4,0,6.1c-6.5,4.6-13.2,9-19.6,13.9c-3.6,2.8-8.3,5.9-9.6,9.8c-4.7,14-14.5,23.7-25.3,32.7c-4,0-8.1,0-12.1,0
								c-8.2-10.9-8.1-13,1.4-22.9c6-6.3,12.5-12.2,18.5-18.4c7.5-7.7,9.8-20,5.5-27.9c-7.8,5.1-10.3,8.7-16.3,23.1
								c-3.9,9.4-14.5,12.3-21.9,5.9c-1.9-1.6-3.2-3.9-4.1-5c-3.8,3.4-7.4,6.4-10.9,9.5c-8.3,7.3-17.9,9.4-28,5.3c-10-4-13.4-12.4-13-22.7
								c0.2-5.1,0-10.2,0-16.5C94.2,163,80.2,181.2,75.2,195c-3.1,8.5-5.9,11-14.7,10.6c-4.8-0.2-9.4-2.5-14.1-3.9
								C46.4,197.7,46.4,193.7,46.4,189.6z"
            />
          </g>
        </svg>
        <span class="navbar__collab">x</span>
        <img class="navbar__logo" src="..//assets/hey-logo.svg" />
      </div>
      <div class="navbar__me">
        <span>Me</span>

        <img
          class="navbar__avatar avatar"
          src="..//assets/heyteam-logo.png"
          alt="BaseCamp"
          title="BaseCamp Careers <basecamp.careers@hey.com>"
          width="50"
          height="50"
        />
      </div>
    </div>

    <DropdownMenu :isVisible="showDropdown" @toggle-dropdown="$emit('toggle-dropdown')" />
  </nav>
</template>

<script>
import DropdownMenu from "./DropdownMenu.vue";

export default {
  name: "Nav",
  props: ["showDropdown"],
  components: {
    DropdownMenu
  },
  methods: {
    handleKeyDown: function(e) {
      // Toggle the dropdown with the 'h' key
      if (e.key === "h") {
        this.$emit("toggle-dropdown");
      }
      // If the dropdown is open, close it with the escape key
      if (e.key === "Escape" && this.showDropdown) {
        this.$emit("toggle-dropdown");
      }
    }
  },
  created() {
    window.addEventListener("keydown", this.handleKeyDown);
  },
  destroyed() {
    window.removeEventListener("keydown", this.handleKeyDown);
  }
};
</script>

